import { render, staticRenderFns } from "./SkillsDetails.vue?vue&type=template&id=6f8db94e&scoped=true&"
import script from "./SkillsDetails.vue?vue&type=script&lang=ts&"
export * from "./SkillsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SkillsDetails.vue?vue&type=style&index=0&id=6f8db94e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8db94e",
  null
  
)

export default component.exports